<template>
  <div class="p-4 tempat-list-page">
    <router-link
      to="/"
      class="back-icon-btn"
      title="Kembali ke Halaman Utama"
      aria-label="Kembali ke Halaman Utama"
    >
      <span class="back-icon" aria-hidden="true">&larr;</span>
      <span class="back-text">Beranda</span>
    </router-link>

    <h1 class="text-2xl font-bold mb-4">Daftar Tempat Asal</h1>

    <div class="search-wrap">
      <input
        v-model.trim="searchQuery"
        type="text"
        class="search-input"
        placeholder="Cari nama tempat atau kategori..."
      >
      <p class="search-meta" v-if="!loading && !error">
        Menampilkan {{ totalVisibleTempat }} dari {{ totalTempat }} tempat
      </p>
    </div>

    <div v-if="loading">Memuat...</div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else>
      <div v-if="filteredGrouped.length" class="category-grid">
        <section v-for="group in filteredGrouped" :key="group.tipe" class="category-card">
          <div class="category-head">
            <h2 class="category-title">{{ formatTipe(group.tipe) }}</h2>
            <span class="category-count">{{ group.tempatList.length }} tempat</span>
          </div>

          <div class="tempat-grid">
            <router-link
              v-for="tempat in group.tempatList"
              :key="tempat"
              :to="`/detail/${encodeURIComponent(tempat)}`"
              class="tempat-item"
            >
              {{ formatNama(tempat) }}
            </router-link>
          </div>
        </section>
      </div>

      <div v-else class="empty-state">
        Tidak ada tempat yang cocok dengan kata kunci "{{ searchQuery }}".
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TempatAsal',
  data() {
    return {
      tempatList: [],
      searchQuery: '',
      loading: true,
      error: null
    }
  },
  computed: {
    orderedGrouped() {
      const grouped = this.tempatList.reduce((acc, curr) => {
        if (!acc[curr.tipe]) {
          acc[curr.tipe] = []
        }

        acc[curr.tipe].push(curr.nama)
        return acc
      }, {})

      const orderedTipe = Object.keys(grouped).sort((a, b) => this.formatTipe(a).localeCompare(this.formatTipe(b)))

      return orderedTipe.map(tipe => ({
        tipe,
        tempatList: grouped[tipe].sort((a, b) => this.formatNama(a).localeCompare(this.formatNama(b)))
      }))
    },
    filteredGrouped() {
      const keyword = this.searchQuery.toLowerCase()

      if (!keyword) {
        return this.orderedGrouped
      }

      return this.orderedGrouped
        .map(group => {
          const matchedByCategory = this.formatTipe(group.tipe).toLowerCase().includes(keyword)
          const filteredTempat = matchedByCategory
            ? group.tempatList
            : group.tempatList.filter(tempat => this.formatNama(tempat).toLowerCase().includes(keyword))

          return {
            ...group,
            tempatList: filteredTempat
          }
        })
        .filter(group => group.tempatList.length > 0)
    },
    totalTempat() {
      return this.orderedGrouped.reduce((sum, group) => sum + group.tempatList.length, 0)
    },
    totalVisibleTempat() {
      return this.filteredGrouped.reduce((sum, group) => sum + group.tempatList.length, 0)
    }
  },
  methods: {
    formatTipe(tipe) {
      return tipe.replace('wp:', '').replace(/([a-z])([A-Z])/g, '$1 $2')
    },
    formatNama(nama) {
      return nama
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }
  },
  mounted() {
    const query = `
      PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
      SELECT ?tempat ?tipe WHERE {
        ?tempat rdf:type ?tipe .
        FILTER regex(str(?tipe), "Kerajaan|Keputren|Kesatriyan|Laut|Padhukuhan|Pertapaan|Sungai|Kahyangan")
      }
      ORDER BY ?tipe ?tempat
    `

    axios
      .get('https://app.alunalun.info/fuseki/wayangpurwa/sparql', {
        params: { query, format: 'json' }
      })
      .then(response => {
        const results = response.data.results.bindings
        this.tempatList = results.map(r => ({
          nama: r.tempat.value.split('#').pop(),
          tipe: r.tipe.value.split('#').pop()
        }))
      })
      .catch(err => {
        this.error = 'Gagal memuat data tempat.'
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<style scoped>
.p-4 {
  padding: 32px;
}

.tempat-list-page {
  max-width: 1200px;
  margin: 0 auto;
}

.back-icon-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 999px;
  text-decoration: none;
  color: #1e40af;
  background: linear-gradient(135deg, #dbeafe, #eff6ff);
  border: 1px solid #bfdbfe;
  box-shadow: 0 6px 16px rgba(30, 64, 175, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.back-icon-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(30, 64, 175, 0.16);
  background: linear-gradient(135deg, #bfdbfe, #dbeafe);
}

.back-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #1d4ed8;
  color: #ffffff;
  font-weight: 700;
  line-height: 1;
}

.back-text {
  font-size: 14px;
  font-weight: 600;
}

.search-wrap {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.search-meta {
  margin-top: 8px;
  color: #475569;
  font-size: 14px;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.category-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px;
  background: #ffffff;
}

.category-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.category-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.category-count {
  font-size: 12px;
  color: #334155;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  padding: 2px 10px;
}

.tempat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px;
}

.tempat-item {
  display: block;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  color: #1d4ed8;
  text-decoration: none;
  background: #f8fafc;
  transition: all 0.2s ease;
}

.tempat-item:hover {
  color: #1e40af;
  background: #eaf2ff;
  border-color: #bfdbfe;
}

.empty-state {
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 20px;
  color: #475569;
  background: #f8fafc;
}

@media (max-width: 640px) {
  .p-4 {
    padding: 20px;
  }
}
</style>
